// src/pages/Category.jsx  (ou src/views/Category.jsx selon ta structure)
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from 'react-bootstrap'
import { Parallax } from "react-scroll-parallax"
import { m } from "framer-motion";
import { fadeIn, fadeInUp } from '../../Functions/GlobalAnimations'
import axios from "axios";
import config from "../../config";           // adapte le chemin
import AllCategory from '../../Components/Story/AllCategory'; // adapte le chemin


const Category = (props) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAllCategories = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.REACT_APP_API_URL}/categories_actif`,{
            headers: { 
            'x-api-key': config.SITE_API_KEY
           }});
      setCategories(response?.data?.result || []);
    } catch (error) {
      console.error("Erreur récupération catégories:", error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  return (
        <div style={props.style}>
      
            {/* Parallax Section Start */}
            <m.div className="h-[380px] overflow-hidden sm:h-[200px] relative" {...fadeIn}>
                <Parallax 
                    className="lg-no-parallax bg-cover absolute top-0 left-0 w-full h-full" 
                    translateY={[-40, 40]} 
                    style={{ backgroundImage: `url(/assets/img/webp/portfolio-bg.webp)` }}
                />
                <Container className="h-full relative">
                    <Row className="items-stretch justify-center h-[450px] md:h-[375px] sm:h-[275px]">
                        <Col xl={6} lg={7} md={8} xs={12} className="text-center flex justify-center flex-col">
                            <h2 className="text-darkgray mb-[0px] font-serif font-medium -tracking-[1px] xs:mb-[0px]">Categories</h2>
                        </Col>
                    </Row>
                </Container>
            </m.div>
            {/* Parallax Section End */}

      {/* Liste des catégories */}
      <AllCategory filterData={categories} loading={loading} />
    </div>
  );
};

export default Category;